import { render } from "./Snackbar.vue?vue&type=template&id=15d00b2e&scoped=true&lang=pug"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=15d00b2e&lang=scss&scoped=true"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d00b2e"]])

export default __exports__